// tslint:disable: max-line-length
import { Component, SystemJsNgModuleLoader, Compiler } from "@angular/core";
import { TciTenantModelService } from "../../ng-tenant/tci-tenant.model";
import {
    AbstractTciTenantComponentLoader
} from "../../ng-tenant/tci-tenant-component-loader.component";
import { ITCIAppDetailsMenuOutput, ITCIEnvToolsAgentCreateMenuInput, ITCIEnvToolsAgentMenuOutput } from "../../ng-tenant/tci-tenant-components";
import { TCITenantRemoteServices } from "../../ng-tenant/tci-tenant-remote-services";
import { TciTenantService } from "../../ng-tenant/tci-tenant.service";

import {
    BaseEnvToolsAgentCreateMenuComponentInput,
    BaseEnvToolsAgentCreateMenuComponentOutput
} from "./base-agent-menu";
import {TCITenantLoaderComponent} from "../../ng-tenant/tci-tenant-component";


@TCITenantLoaderComponent({
    isdynamic: true
})
@Component({
    selector: "ng-base-agent-menu",
    template: "<template #dynamic></template>"
})
export class NgBaseAgentMenuComponent
    extends AbstractTciTenantComponentLoader<ITCIEnvToolsAgentMenuOutput, BaseEnvToolsAgentCreateMenuComponentInput, BaseEnvToolsAgentCreateMenuComponentOutput<ITCIEnvToolsAgentMenuOutput>> {
    constructor(
        loader: SystemJsNgModuleLoader,
        compiler: Compiler,
        tenantRemoteServices: TCITenantRemoteServices,
        tenantSvc: TciTenantService,
        tenantModelSvc: TciTenantModelService
    ) {
        super(loader, compiler, tenantRemoteServices, tenantSvc, tenantModelSvc);
    }
}
